import { DeleteOutlined, EyeOutlined, ReloadOutlined } from '@ant-design/icons';
import { useAppDispatch } from '../../../../store/store';
import { Button, Popconfirm, Space } from 'antd';
import { useState } from 'react';
import {
  deleteAllUserNotifications,
  fetchUserNotifications,
  markAllUserNotificationsAsRead,
} from '@hefe/store';
import { t } from '@hefe/i18n';

export default function NotificationsListActionsComponent() {
  const dispatch = useAppDispatch();

  const [markingAllAsRead, setMarkingAllAsRead] = useState(false);
  const [deletingAll, setDeletingAll] = useState(false);
  const [reloading, setReloading] = useState(false);

  const reloadNotifications = () => {
    setReloading(true);
    dispatch(fetchUserNotifications(1))
      .unwrap()
      .catch(() => null)
      .finally(() => setReloading(false));
  };

  const markAllNotificationsAsRead = () => {
    setMarkingAllAsRead(true);
    dispatch(markAllUserNotificationsAsRead())
      .unwrap()
      .catch(() => null)
      .finally(() => setMarkingAllAsRead(false));
  };

  const deleteAllNotifications = () => {
    setDeletingAll(true);
    dispatch(deleteAllUserNotifications())
      .unwrap()
      .catch(() => null)
      .finally(() => setDeletingAll(false));
  };

  return (
    <Space direction="horizontal" align="end">
      <Button
        icon={<ReloadOutlined />}
        loading={reloading}
        onClick={() => reloadNotifications()}
      />
      <Popconfirm
        disabled={markingAllAsRead}
        title={t('notifications.questions.mark_all')}
        onConfirm={() => markAllNotificationsAsRead()}
      >
        <Button icon={<EyeOutlined />} loading={markingAllAsRead} />
      </Popconfirm>
      <Popconfirm
        disabled={deletingAll}
        okType="danger"
        title={t('notifications.questions.delete_all')}
        onConfirm={() => deleteAllNotifications()}
      >
        <Button icon={<DeleteOutlined />} danger loading={deletingAll} />
      </Popconfirm>
    </Space>
  );
}
